export const DEFAULT_PRICE_TAX_MODE = 'tax-inclusive';

export const PRICE_TAX_MODES = [
  {
    value: DEFAULT_PRICE_TAX_MODE,
    label: 'Tax-inclusive prices',
  },
  {
    value: 'tax-exclusive',
    label: 'Tax-exclusive prices',
  },
];

export const DEFAULT_TAX_CATEGORY = 'standard_gct_15';

export const TAX_CATEGORIES = [
  {
    value: DEFAULT_TAX_CATEGORY,
    label: 'Standard-rated (15% GCT)',
    rate: 0.15,
  },
  {
    value: 'zero_rated',
    label: 'Zero-rated (0% GCT)',
    rate: 0,
  },
  {
    value: 'exempt',
    label: 'Exempt (0% GCT)',
    rate: 0,
  },
  {
    value: 'custom',
    label: 'Custom GCT rate',
    rate: null,
  },
];

export const getDefaultTaxRateForCategory = (taxCategory) => {
  const category = TAX_CATEGORIES.find((option) => option.value === taxCategory);
  return category && category.rate !== null ? category.rate : null;
};
